import "./RoboticsCourseHP3.module.css";
import Header from "@/reusable_sections/Header";
import CourseOverview from "./sections/CourseOverview";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseHP3Page() {
  return <div>
      <Header />
      <CourseOverview />
      <Footer />
    </div>;
}